/**
 * @flow
 * @relayHash d3d6a1e07add8c0c26ed5254fb95261c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShopDetailsBreadcrumbsQueryVariables = {|
  id: string
|};
export type ShopDetailsBreadcrumbsQueryResponse = {|
  +shop: ?{|
    +ref_id: string,
    +name: ?string,
    +slug: ?string,
    +vendor_track: ?{|
      +ref_id: string,
      +name: ?string,
      +track_type: ?string,
    |},
    +departments: ?$ReadOnlyArray<?{|
      +ref_id: string,
      +name: string,
      +enabled: ?boolean,
      +icon: ?string,
      +position: ?number,
    |}>,
  |}
|};
export type ShopDetailsBreadcrumbsQuery = {|
  variables: ShopDetailsBreadcrumbsQueryVariables,
  response: ShopDetailsBreadcrumbsQueryResponse,
|};
*/


/*
query ShopDetailsBreadcrumbsQuery(
  $id: ID!
) {
  shop(id: $id) {
    ref_id
    name
    slug
    vendor_track {
      ref_id
      name
      track_type
      id
    }
    departments {
      ref_id
      name
      enabled
      icon
      position
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "track_type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enabled",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "icon",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopDetailsBreadcrumbsQuery",
  "id": null,
  "text": "query ShopDetailsBreadcrumbsQuery(\n  $id: ID!\n) {\n  shop(id: $id) {\n    ref_id\n    name\n    slug\n    vendor_track {\n      ref_id\n      name\n      track_type\n      id\n    }\n    departments {\n      ref_id\n      name\n      enabled\n      icon\n      position\n      id\n    }\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopDetailsBreadcrumbsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shop",
        "storageKey": null,
        "args": v1,
        "concreteType": "Shop",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vendor_track",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorTrack",
            "plural": false,
            "selections": [
              v2,
              v3,
              v5
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "departments",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackDepartment",
            "plural": true,
            "selections": [
              v2,
              v3,
              v6,
              v7,
              v8
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopDetailsBreadcrumbsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shop",
        "storageKey": null,
        "args": v1,
        "concreteType": "Shop",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vendor_track",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorTrack",
            "plural": false,
            "selections": [
              v2,
              v3,
              v5,
              v9
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "departments",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackDepartment",
            "plural": true,
            "selections": [
              v2,
              v3,
              v6,
              v7,
              v8,
              v9
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'efe772f79c55e5f0f5dac1a89c0ffc19';
module.exports = node;
